import { AppDispatch } from "@Reducers/index";
import { setLayout } from "../reducers/layout";
import axiosWrapper from "../services/axiosWrapper";

export function fetchLayout() {
  return async (dispatch: AppDispatch) => {
    const response = await axiosWrapper.api.get("/portal/getLayoutData");
    if (response.data.status) {
      dispatch(setLayout(response.data.result));
    }
  };
}
